// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { GetFeishuDepsSearchQuery, BaseResponseListFeishuDepFoundResponse } from '../../types';

/**
 * 根据名称查询部门
 *
 * @export
 * @tags feishu-dep-controller
 * @link [GET] /feishuDeps/search
 */
export function getFeishuDepsSearch(
    options: ApiOptions<never, GetFeishuDepsSearchQuery> & { params: GetFeishuDepsSearchQuery }
): Promise<BaseResponseListFeishuDepFoundResponse> {
    return request<never, never, GetFeishuDepsSearchQuery>('/feishuDeps/search', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuDepsSearch',
    });
}

export const meta = [
    { tags: ['feishu-dep-controller'], path: '/feishuDeps/search', method: 'get' },
];
